import styled, { css } from 'styled-components';
export const Wrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;

  ${({ height }) => height &&
    css `
      height: ${height};
    `};

  ${({ theme, inner }) => inner
    ? css `
          border: 1px solid ${theme.colors.grey10_1};
        `
    : theme.shadows.small}
`;
export const ItemsWrapper = styled.div `
  display: flex;
  flex-direction: ${({ horizontal }) => (horizontal ? 'row' : 'column')};
  flex: 1;
  min-height: 0;
  overflow: auto;

  ${({ theme, hasTitle }) => hasTitle &&
    css `
      border-top: 1px solid ${theme.colors.grey10_1};
    `}

  & > *:not(:first-child) {
    border-top: ${({ horizontal, theme }) => (horizontal ? 'none' : `1px solid ${theme.colors.grey10_1}`)};
    border-left: ${({ horizontal, theme }) => (horizontal ? `1px solid ${theme.colors.grey10_1}` : 'none')};
  }

  ${({ horizontal }) => horizontal &&
    css `
      & > * {
        flex: 1 1 0;
        min-width: 0;
      }
    `}
`;
